import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, Images, PermissionsList, RolePermission, useModal } from 'utils';
import { LoadSummary } from '../../createLoad/core/loadSummary';
import { EditGroup } from './editGroup';
import { GroupLoads } from './groupLoads';
import { GroupDocuments } from './groupDocuments';
import { GroupTotals } from './groupTotals';
import { BILLABLE } from '../../../../pages/accounting/constants';
import { paymentVerificationDetailsStyle } from '../../../paymentVerification/paymentVerificationDetails/styles';
import { groupStatusEnums } from './constants';
import { CustomDeleteModal } from '../../../modals';
import { loadActions } from 'store';
import { loadsStyle } from '../../../../pages/loads/styles';

const CANCEL_ACTION_TYPE = 'CANCEL_GROUPED_LOADS';
export const GroupDetails = ({ afterSuccess }) => {
  const { groupById } = useSelector((state) => ({
    groupById: state.loads.groupById,
  }));
  const dispatch = useDispatch();
  const { open, close } = useModal();
  const classes = paymentVerificationDetailsStyle();
  const loadClasses = loadsStyle();
  const cancelLoader = FindLoad(CANCEL_ACTION_TYPE);

  return (
    <div>
      <div>
        <LoadSummary loadById={groupById} grouped={true} />

        {(!groupById?.readyForBilling && groupById?.billStatus === BILLABLE) &&
          <div className={classes.warnWrapper} style={{ margin: '0 0 32px' }}>
            <img src={Images.warning} alt="icon" />
            <div className={classes.text}>
              <p style={{ fontWeight: 'bold' }}>Warning:  &nbsp;</p>
              <span>All loads with “Group Billing” are in Processing. If no more will be added, please turn ON ‘Ready for Billing’.</span>
            </div>
          </div>
        }

        <GroupTotals groupById={groupById}  />
        <EditGroup afterSuccess={afterSuccess}/>
        <GroupLoads afterSuccess={afterSuccess} />
        <GroupDocuments info={groupById} id={groupById?.id} />
      </div>

      {RolePermission([PermissionsList.CANCEL_LOAD?.code], 'agentView') &&
        groupById?.status &&
        groupById?.status !== groupStatusEnums.CANCELLED &&
        <div className={loadClasses.cancelLoadWrapper}>
          <button
            className={loadClasses.cancelLoad}
            onClick={() => open(
              <CustomDeleteModal
                modalText={'Are you sure you want to cancel this Group loads?'}
                cancelButton={'Cancel Group'}
                closeButton={'Go Back'}
                loading={!!cancelLoader?.length}
                actionType={CANCEL_ACTION_TYPE}
                text="Cancel Group Loads?"
                info={'Load'}
                handleDel={() => dispatch(loadActions.cancelGroup(groupById?.id))}
                afterSuccess={() => {
                  if(afterSuccess) {
                    afterSuccess()
                  }
                  close()
                }}
              />,
            )}
          >
            Cancel Group Loads
          </button>
        </div>
      }
    </div>
  );
};